/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import Widget from '../../common/Widget/Widget'
import ClientsTable from '../Clients/components/ClientsTable'
import ClientsTableHeader from '../Clients/components/ClientsTableHeader'
import Container from '../../common/Container/Container'
import { Button } from '../../common/Button/Button'

import PopUp from '../../common/PopUp/PopUp'
import DatePicker from '../../common/DatePicker/DatePicker'
import { currency, symbol } from '../../common/CurrencyFormat'

/**
 *     Import
 *     - CSS
 */
import './styles/Search.css'

/**
 *     Import
 *     - Images
 */
import { SearchIcon } from '../../../images/icons/Search/Search'

/**
 * Clients section class
 *
 * @export
 * @class Clients
 * @extends {React.Component<any, any>}
 */

const errorTiltle = {
    title: 'Something went wrong',
    btnTxt: 'Close',
}

export default class Search extends React.Component<any, any> {
    clientListStateVoid = {
        policyList: {
            policies: [],
        },
        quoteList: {
            quotes: [],
        },
    }
    /**
     * Creates an instance of Clients.
     * @param {*} props
     * @memberof Clients
     */
    constructor(props: any) {
        super(props)
        this.state = {
            tabSelected: 'all',
            searchText: '',
            searchButtonVisible: false,
            clientList: {
                policyList: {
                    policies: [],
                },
                quoteList: {
                    quotes: [],
                },
            },
            policiesFilter: {
                page: 1,
                perPage: 20,
                sortedBy: 'clientName',
                sortedType: 'asc',
            },
            quotesFilter: {
                page: 1,
                perPage: 20,
                sortedBy: 'clientName',
                sortedType: 'asc',
            },
            bindPopUp: {
                show: false,
                quoteId: '',
                quoteVariationId: '',
                businessName: '',
                quoteRef: '',
                inceptionDate: '',
                printDate: '',
                premium: Number,
                commission: '',
                excess: Number,
                isCollectors: false,
                isDealersStock: false,
                isMuseums: false,
                bespokePolicyId: '',
            },
            bindPopUpSendShow: false,
            quoteVariationId: '',
            boundBind: false,
            bindLoading: false,
            bindError: false,
            errorPopup: {
                ...errorTiltle,
            },
        }
    }

    // componentWillReceiveProps(nextProps: any) {
    //     if (nextProps.searchResult.response &&
    //         (this.state.clientList.policyList !== nextProps.searchResult.response.policies ||
    //             this.state.clientList.quoteList !== nextProps.searchResult.response.quotes)) {
    //         let clientListState = JSON.parse(JSON.stringify(this.clientListStateVoid)) // For cloning the object

    //         clientListState.policyList.policies = nextProps.searchResult.response.policies
    //         clientListState.quoteList.quotes = nextProps.searchResult.response.quotes

    //         this.setState({ clientList: clientListState })
    //     }
    // }

    componentDidUpdate(prevProps: any, nextState: any) {
        const { quotesList, policiesList, searchResult } = this.props
        if (this.state.policiesFilter !== nextState.policiesFilter ||
            this.state.quotesFilter !== nextState.quotesFilter
        ) {
            this.newSearch()
        }

        if (prevProps.quotesList !== quotesList && prevProps.policiesList !== policiesList &&
            prevProps.searchResult.response !== searchResult.response) {
            let clientListState = JSON.parse(JSON.stringify(this.clientListStateVoid))
            clientListState.policyList.policies = policiesList
            clientListState.quoteList.quotes = quotesList

            this.setState({ clientList: clientListState })
        }

    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    changeTab = (tabSelected: string) => {
        this.setState({ tabSelected })
    }

    searchNewType = (event) => {
        let keyCode = event.keyCode || event.which
        if (keyCode === 13) {
            this.newSearch()
        } else if (event.target.value !== '') {
            this.setState({ searchButtonVisible: true, searchText: event.target.value })
        } else {
            this.props.searchResult.done = null
            this.setState({ searchButtonVisible: false, searchText: '', clientList: this.clientListStateVoid })
        }
    }

    newSearch = () => {
        if (this.state.searchText !== '') {
            this.props.fetchSearch(this.state.searchText, {
                quotesSortedType: this.state.quotesFilter.sortedType,
                quotesSortedBy: this.state.quotesFilter.sortedBy,
                pageQuotes: this.state.quotesFilter.page,
                perPageQuotes: this.state.quotesFilter.perPage,
                policiesSortedType: this.state.policiesFilter.sortedType,
                policiesSortedBy: this.state.policiesFilter.sortedBy,
                pagePolicies: this.state.policiesFilter.page,
                perPagePolicies: this.state.policiesFilter.perPage,
            })
        } else {
            this.setState({ clientList: this.clientListStateVoid })
        }
    }

    /**
     * Trigger fot the header filters
     *
     * @memberof Search
     * @param {Object} params
     * @param {String} type
     */
    filterTrigger = (params: object, type: string) => {
        if (type === 'quotes') {
            this.setState({ quotesFilter: params })
        } else {
            this.setState({ policiesFilter: params })
        }
    }

    /**
     * Handle the action of binding the quote from the PopUp
     *
     * @param {*} quoteId
     * @param {*} quoteVariationId
     * @memberof Clients
     */
    handleBind = (quoteId: any, quoteVariationId: any, inceptionDate: any, bespokePolicyId: any) => {
        this.setState({ bindLoading: true })
        this.props.bindQuoteVariation(quoteId, quoteVariationId, inceptionDate, bespokePolicyId).then((response) => {
            if (response.value) {
                setTimeout(
                    () => {
                        this.setState({
                            boundBind: true,
                            bindLoading: false,
                        })
                        this.newSearch()
                    },
                    300)
            }
        }).catch((response) => {
            if (response.error) {
                setTimeout(
                    () => {
                        this.setState({
                            boundBind: false,
                            bindLoading: false,
                            bindError: response.error,
                            errorPopup: response.variation ? {
                                title: 'Quote Referred',
                                btnTxt: 'Close',
                            } : {
                                ...errorTiltle,
                            },
                        })
                    },
                    300)
            }
        })
        this.setState(
            {
                bindPopUp: {
                    show: false,
                    quoteId: '',
                    quoteVariationId: '',
                    businessName: '',
                    quoteRef: '',
                    inceptionDate: '',
                    printDate: '',
                    premium: Number,
                    commission: '',
                    excess: Number,
                    bespokePolicyId: '',
                    isCollectors: false,
                    isDealersStock: false,
                    isMuseums: false,
                },
                bindPopUpSendShow: false,
                quoteVariationId,
            }
        )
    }

    printDate = () => {
        return this.state.bindPopUp.printDate
    }

    handleInput = (event) => {
        let _bindpopup = this.state.bindPopUp
        _bindpopup.bespokePolicyId = event.target.value
        this.setState({ bindPopUp: _bindpopup })
    }

    render() {
        const { errorPopup } = this.state
        return (
            <div className="search">
                {/* {
                    (this.props.step05.error) ?
                        < PopUp
                            title="Something went wrong"
                            buttonText="Close"
                            action={() => {
                                this.props.step05.error = null
                                this.forceUpdate()
                            }}
                        >
                            {this.props.step05.error.error}
                        </ PopUp>
                        :
                        null
                } */}

                {
                    (this.state.bindError) ?
                        <PopUp
                            title={errorPopup.title}
                            buttonText={errorPopup.btnTxt}
                            action={() => {
                                this.setState({ bindError: false, errorPopup: { ...errorTiltle } })
                                this.props.step05.error = null
                            }}
                        >
                            {this.state.bindError}
                        </PopUp> : null
                }

                {
                    (this.state.bindLoading) ?
                        <PopUp
                            title="Quote Bound Loading"
                            action={() => ('')}
                        >
                            ...loading
                        </PopUp> : null
                }

                {
                    (this.state.boundBind) ?
                        <PopUp
                            title="Quote Bound"
                            buttonText="Quote Bound"
                            action={() => this.setState({
                                boundBind: false,
                            })}
                        >
                            The quote has been bound
                        </PopUp> : null
                }

                {
                    this.state.bindPopUp.show &&
                    < PopUp
                        title="Select Inception Date"
                        buttonText="Cancel"
                        action={
                            () =>
                                this.setState(
                                    {
                                        bindPopUp: {
                                            show: false,
                                            quoteId: '',
                                            quoteVariationId: '',
                                            businessName: '',
                                            quoteRef: '',
                                            inceptionDate: '',
                                            printDate: '',
                                            premium: Number,
                                            commission: '',
                                            excess: Number,
                                            bespokePolicyId: '',
                                            isCollectors: false,
                                            isDealersStock: false,
                                            isMuseums: false,
                                        },
                                    }
                                )
                        }
                    >
                        <div className="quotePreview__box">
                            {/* {(bindPopUp.isCollectors || bindPopUp.isMuseums || bindPopUp.isDealersStock) && */}
                            <div className="quotePreview__row">
                                <div className="text">
                                    Bespoke Policy ID:
                                </div>
                                <div className="quotePreview__row__inception_date">
                                    <input
                                        type="text"
                                        name="bespokePolicyId"
                                        placeholder="Bespoke Policy ID"
                                        onChange={this.handleInput}
                                    />
                                </div>
                            </div>
                            {/* } */}
                            <div className="quotePreview__row">
                                <div className="text">
                                    Please enter the inception date:
                                </div>
                                <div className="quotePreview__row__inception_date">
                                    <DatePicker
                                        placeholder="Policy inception date"
                                        step05inceptionDate={this.printDate()}
                                        onChange={(inceptionDate) => this.setState(
                                            {
                                                bindPopUp:
                                                    { ...this.state.bindPopUp, inceptionDate, show: false },
                                                bindPopUpSendShow: true,
                                            }
                                        )}
                                        onFocus={() => null}
                                    />
                                </div>
                            </div>
                        </div>
                    </PopUp >
                }
                {
                    (this.state.bindPopUpSendShow) ?
                        < PopUp
                            title="Do you want to bind this quote?"
                            buttonText="Bind"
                            action={
                                () => {
                                    this.handleBind(
                                        this.state.bindPopUp.quoteId,
                                        this.state.bindPopUp.quoteVariationId,
                                        this.state.bindPopUp.inceptionDate,
                                        this.state.bindPopUp.bespokePolicyId
                                    )
                                }
                            }
                            numberButtons={2}
                            secondaryButtonText="Cancel"
                            secondaryAction={
                                () =>
                                    this.setState(
                                        {
                                            bindPopUp: {
                                                show: false,
                                                quoteId: '',
                                                quoteVariationId: '',
                                                businessName: '',
                                                quoteRef: '',
                                                inceptionDate: '',
                                                printDate: '',
                                                premium: Number,
                                                commission: '',
                                                excess: Number,
                                                bespokePolicyId: '',
                                                isCollectors: false,
                                                isDealersStock: false,
                                                isMuseums: false,
                                            },
                                            bindPopUpSendShow: false,
                                        }
                                    )
                            }
                        >
                            <div className="quotePreview__box">
                                <div className="quotePreview__header">
                                    <div className="quotePreview__header__title">
                                        {this.state.bindPopUp.businessName}
                                    </div>
                                    <div className="quotePreview__header__subtitle">
                                        {this.state.bindPopUp.policyName || 'Art and Antiques Dealer'} Policy
                                    </div>
                                    <div className="quotePreview__header__policyInfo">
                                        Policy no. <span>{this.state.bindPopUp.quoteRef}</span>
                                    </div>
                                </div>

                                <div className="quotePreview__row">
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Inception date</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{this.state.bindPopUp.inceptionDate}</span>
                                        </div>
                                    </div>
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Date quoted</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{this.state.bindPopUp.printDate}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="quotePreview__row">
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Premium</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{currency(this.state.bindPopUp.premium)}</span> inc.IPT
                                        </div>
                                    </div>
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Your commission</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{this.state.bindPopUp.commission}%</span>
                                        </div>
                                    </div>
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Excess</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{symbol()} {this.state.bindPopUp.excess}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </PopUp > :
                        null
                }
                <div className="search__header">
                    <div className="search__header__content">
                        <div className="search__header__content__searching-bar">
                            <div>
                                <SearchIcon />
                            </div>
                            <div className="separator" />
                            <div className="input">
                                <input
                                    placeholder="Start typing to search"
                                    type="text"
                                    onKeyUp={(event) => { this.searchNewType(event) }}
                                />
                            </div>
                            <div>
                                <Button
                                    className={`search_button ${(this.state.searchButtonVisible) ? 'active' : ''}`}
                                    onClick={() => { this.newSearch() }}
                                >
                                    Search
                                </Button>
                            </div>
                        </div>
                        <div className="search__header__content__tabs">
                            <div className="search__header__content__tabs--results">
                                {(this.state.tabSelected === 'all' &&
                                    (this.state.clientList.policyList.policies.length +
                                        this.state.clientList.quoteList.quotes.length > 0)) ?
                                    `${this.state.clientList.policyList.policies.length +
                                    this.state.clientList.quoteList.quotes.length
                                    } ${this.state.clientList.policyList.policies.length +
                                        this.state.clientList.quoteList.quotes.length === 1 ?
                                        'result' :
                                        'results'
                                    }` :
                                    ''
                                }
                            </div>
                            <div className="search__header__content__tabs--buttons">
                                <div
                                    onClick={() => { this.changeTab('policies') }}
                                    className={(this.state.tabSelected === 'policies') ? 'active' : ''}
                                >
                                    Policies
                                </div>
                                <div
                                    onClick={() => { this.changeTab('quotes') }}
                                    className={(this.state.tabSelected === 'quotes') ? 'active' : ''}
                                >
                                    Quotes
                                </div>
                                <div
                                    onClick={() => { this.changeTab('all') }}
                                    className={(this.state.tabSelected === 'all') ? 'active' : ''}
                                >
                                    All
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="search__body">
                    {
                        (this.state.clientList.policyList.policies.length === 0 &&
                            this.state.clientList.quoteList.quotes.length === 0 &&
                            !this.props.searchResult.done
                        ) ?
                            (
                                <div className="search__body--no-results">
                                    <SearchIcon />
                                </div>
                            ) :
                            (
                                <div className="search__body--results">
                                    <Widget
                                        shadow={true}
                                        className={
                                            `search-quotes
                                            ${(this.state.clientList.quoteList.quotes.length === 0) ?
                                                'search-quotes__void' : ''}
                                            ${(this.state.tabSelected !== 'all'
                                                && this.state.tabSelected !== 'quotes') ?
                                                'search-quotes__blocked' : ''}
                                            `}
                                    >
                                        <div className="search-quotes__title">
                                            <h3>Quotes</h3>
                                            <p>
                                                {`${this.state.clientList.quoteList.quotes.length
                                                    } ${this.state.clientList.quoteList.quotes.length > 1 ?
                                                        'results' :
                                                        'result'
                                                    }`
                                                }
                                            </p>
                                        </div>
                                        <div className="your-quotes__content">
                                            <Container
                                                className="clients clients__table table__content"
                                                fullwidth={false}
                                            >
                                                <ClientsTableHeader
                                                    dataType="quotes"
                                                    filterTrigger={(filters) => this.filterTrigger(filters, 'quotes')}
                                                />
                                                <ClientsTable
                                                    clientList={(this.state.clientList) ? this.state.clientList : {}}
                                                    dataType="quotes"
                                                    confirmEditQuote={this.props.confirmEditQuote}
                                                    history={this.props.history}
                                                    bindClick={
                                                        (quote, variation) => {
                                                            this.setState(
                                                                {
                                                                    bindPopUp: {
                                                                        show: true,
                                                                        quoteId: quote.id,
                                                                        quoteVariationId: variation.id,
                                                                        businessName: quote.clientName,
                                                                        quoteRef: variation.quoteRef,
                                                                        inceptionDate: '',
                                                                        printDate: quote.quotedDate,
                                                                        premium: variation.premium,
                                                                        commission: variation.commission,
                                                                        excess: variation.excess,
                                                                        policyName: quote.policyName,
                                                                        bespokePolicyId: '',
                                                                        isCollectors: quote.isCollectors,
                                                                        isDealersStock: quote.isDealersStock,
                                                                        isMuseums: quote.isMuseums,
                                                                    },
                                                                }
                                                            )
                                                        }
                                                    }
                                                />
                                            </Container>
                                        </div>
                                    </Widget>
                                    <div
                                        className={`no-results-widget
                                        ${(this.state.clientList.quoteList.quotes.length === 0) ? 'active' : ''}
                                        ${(this.state.tabSelected !== 'all' && this.state.tabSelected !== 'quotes') ?
                                                'blocked' : ''}`}
                                    >
                                        Search returned no results in quotes
                                    </div>
                                    <Widget
                                        shadow={true}
                                        className={
                                            `search-policies
                                            ${(this.state.clientList.policyList.policies.length === 0) ?
                                                'search-policies__void' : ''}
                                            ${(this.state.tabSelected !== 'all'
                                                && this.state.tabSelected !== 'policies') ?
                                                'search-policies__blocked' : ''}`}
                                    >
                                        <div className="search-policies__title">
                                            <h3>Policies</h3>
                                            <p>
                                                {`${this.state.clientList.policyList.policies.length
                                                    } ${this.state.clientList.policyList.policies.length > 1 ?
                                                        'results' :
                                                        'result'
                                                    }`
                                                }
                                            </p>
                                        </div>
                                        <div className="your-policies__content">
                                            <Container
                                                className="clients clients__table table__content"
                                                fullwidth={false}
                                            >
                                                <ClientsTableHeader
                                                    dataType="policies"
                                                    filterTrigger={(filters) => this.filterTrigger(filters, 'policies')}
                                                />
                                                <ClientsTable
                                                    clientList={(this.state.clientList) ? this.state.clientList : {}}
                                                    dataType="policies"
                                                    history={this.props.history}
                                                />
                                            </Container>
                                        </div>
                                    </Widget>
                                    <div
                                        className={`no-results-widget
                                        ${(this.state.clientList.policyList.policies.length === 0) ? 'active' : ''}
                                        ${(this.state.tabSelected !== 'all' && this.state.tabSelected !== 'policies') ?
                                                'blocked' : ''}`}
                                    >
                                        Search returned no results in policies
                                    </div>
                                </div>
                            )
                    }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Search/Search.tsx